function isValidCookieDomain() {
  let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!value.length || value.length > 255) {
    return false;
  }
  return /^\.?(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/.test(value);
}
function validateCookieDomain(_, value, callback) {
  if (isValidCookieDomain(value) || value === '') {
    callback();
  } else {
    callback(new Error('Please enter a valid cookie domain.'));
  }
}
function validateCookieTTL(_, value, callback) {
  if (Number(value) && value > 0 || value === '') {
    callback();
  } else {
    callback(new Error('Please enter a number of days greater than 0.'));
  }
}

export { isValidCookieDomain, validateCookieDomain, validateCookieTTL };
//# sourceMappingURL=utils.js.map
